import { z } from "zod";

// Import semua skema V4 yang relevan
import { SalesReportFilterSchemaV4 } from "../../../services/cm-group-report/schema/SalesReportFilterSchemaV4";
import { RoomReportFilterSchemaV4 } from "../../../services/cm-group-report/schema/RoomReportFilterSchemaV4";
import { ReportAgentFilterSchemaV4 } from "../../../services/cm-group-report/schema/ReportAgentFilterSchemaV4";
import { DailyReportFilterSchemaV4 } from "../../../services/cm-group-report/schema/DailyReportFilterSchemaV4";
import { CountryReportFilterSchemaV4 } from "../../../services/cm-group-report/schema/CountryReportFilterSchemaV4";
import { ReservationReportFilterSchemaV4 } from "../../../services/cm-group-report/schema/ReservationReportFilterSchemaV4";
import { ReportSalesMonthlyFilterSchemaV4 } from "../../../services/cm-group-report/schema/ReportSalesMonthlyFilterSchemaV4"; // <-- BARU
import { OccupancyReportFilterSchemaV4 } from "../../../services/cm-group-report/schema/OccupancyReportFilterSchemaV4"; // <-- BARU

const BaseSchema = z.object({
    report_type: z.enum([
        "report_agent",
        "daily_report",
        "sales_report",
        "report_reservation",
        "report_sales_monthly",
        "room_report",
        "country_report",
        "occupancy_report"
    ])
});

// Menggunakan skema V4 untuk semua laporan yang telah dikemas kini
const SalesReportSchema = BaseSchema.extend({ filter: SalesReportFilterSchemaV4 });
const RoomReportSchema = BaseSchema.extend({ filter: RoomReportFilterSchemaV4 });
const DailyReportSchema = BaseSchema.extend({ filter: DailyReportFilterSchemaV4 });
const ReportAgentSchema = BaseSchema.extend({ filter: ReportAgentFilterSchemaV4 });
const CountryReportSchema = BaseSchema.extend({ filter: CountryReportFilterSchemaV4 });
const ReportReservationSchema = BaseSchema.extend({ filter: ReservationReportFilterSchemaV4 });
const ReportSalesMonthlySchema = BaseSchema.extend({ filter: ReportSalesMonthlyFilterSchemaV4 }); // <-- BARU: Guna skema V4
const OccupancyReportSchema = BaseSchema.extend({ filter: OccupancyReportFilterSchemaV4 }); // Schema for occupancy_report without base_on

export const schemaMap = {
    sales_report: SalesReportSchema,
    daily_report: DailyReportSchema,
    report_reservation: ReportReservationSchema,
    report_sales_monthly: ReportSalesMonthlySchema,
    report_agent: ReportAgentSchema,
    room_report: RoomReportSchema,
    country_report: CountryReportSchema,
    occupancy_report: OccupancyReportSchema,
};

export const defaultValuesMap = {
    sales_report: { report_type: "sales_report", filter: { property_id: "", base_on: "checkout_date", start_date: "", end_date: "" } },
    daily_report: { report_type: "daily_report", filter: { property_id: "", base_on: "stay_date", start_date: "", end_date: "" } },
    report_reservation: { report_type: "report_reservation", filter: { property_id: "", base_on: "created_reservation", start_date: "", end_date: "" } },
    // ================== PERUBAHAN DI SINI ==================
    report_sales_monthly: { report_type: "report_sales_monthly", filter: { property_id: "", base_on: "created_reservation", start_date: "", end_date: "" } },
    // =======================================================
    report_agent: { report_type: "report_agent", filter: { property_id: "", base_on: "stay_date", start_date: "", end_date: "" } },
    room_report: { report_type: "room_report", filter: { property_id: "", base_on: "stay_date", start_date: "", end_date: "" } },
    country_report: { report_type: "country_report", filter: { property_id: "", base_on: "created_reservation", start_date: "", end_date: "" } },
    occupancy_report: { report_type: "occupancy_report", filter: { property_id: "", year: new Date().getFullYear() } },
};